import { useCallback, useMemo, useState } from 'react'
import { useSharedContext } from '@leverege/ui-plugin'

import { DateTime } from 'luxon'
import { OperatingHours } from '@leverege/operating-hours'
import { getOpenHoursFromOperatingHours } from '../../../../util'

export default function useTrafficData( opts ) {
  const { events } = opts

  const { operatingHours } = useSharedContext()
  const [ type, setType ] = useState( 'count' )
  const onSetType = useCallback( ( { data } ) => {
    setType( data )
  }, [] )

  const { data } = useMemo( () => {
    const openHours = getOpenHoursFromOperatingHours( operatingHours, false )
    const timezone = OperatingHours.getTimezone( operatingHours )
    const ret = openHours.reduce( ( prev, hour ) => {
      prev[hour] = {
        dog : 0,
        person : 0,
        dates : new Set()
      }

      return prev
    }, {} )

    const start = DateTime.fromISO( events.start )
    const end = DateTime.fromMillis(
      Math.min(
        new Date( events.end ),
        DateTime.local().setZone( operatingHours.timezone, { keepLocalTime : true } )
      )
    )

    for ( let i = start; i < end; i = i.plus( { hour : 1 } ) ) {
      const hour = i.get( 'hour' )
      const date = i.toISODate()

      if ( ret[hour] && !ret[hour].dates.has( date ) ) {
        ret[hour].dates.add( date )
      }
    }

    events?.items?.forEach( ( item ) => {
      const { time, data } = item
      const dateTime = DateTime
        .fromISO( time )
        .setZone( timezone )
      const hour = dateTime.get( 'hour' )

      if ( ret[`${hour}`] ) {
        if ( data.data?.changes?.person != null ) {
          ret[`${hour}`].person += 1
        }

        if ( data.data?.changes?.dog != null ) {
          ret[`${hour}`].dog += 1
        }
      }
    } )

    const d = Object
      .entries( ret )
      .map( ( [ hour, data ] ) => {

        return {
          hour,
          person : data.person,
          dog : data.dog,
          dates : data.dates
        }
      } )

    return {
      data : d
    }
  }, [ events, operatingHours ] )

  const config = useMemo( () => {
    return {
      scale : {
        x : { type : 'point' },
        y : { type : 'linear' }
      },
      accessors : {
        person : {
          xAccessor : d => d.hour,
          yAccessor : ( d ) => {
            return type === 'count' ? d.person : Math.round( d.person / d.dates.size )
          }
        },
        dog : {
          xAccessor : d => d.hour,
          yAccessor : ( d ) => {
            return type === 'count' ? d.dog : Math.round( d.dog / d.dates.size )
          }

        }
      },
      tickFormat : {
        x : ( value ) => {
          const int = parseInt( value )

          if ( int <= 12 ) {
            return `${int}`
          }

          return `${int - 12}`
        }
      }
    }
  }, [ type ] )

  return {
    data,
    config,
    type,
    onSetType
  }
}
